import de from 'date-fns/locale/de';
import enGB from 'date-fns/locale/en-GB';
import fr from 'date-fns/locale/fr';
import it from 'date-fns/locale/it';
import nl from 'date-fns/locale/nl';
import sv from 'date-fns/locale/sv';

export const locales: { [key: string]: Locale } = {
    itIT: it,
    frFR: fr,
    deCH: de,
    nlNL: nl,
    svSE: sv,
    enGB
};

export const transformLanguageCode = (lang = 'en-gb') => {
    const [languageCode, countryCode] = lang.split('-');
    return `${languageCode}${countryCode.toUpperCase()}`;
};
